import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ExtendedProvider, Log } from 'Src/types';
import { CtaListItemBase, ListItemButtonProps } from './CtaListItemBase';
import { DefaultCtaListItem, trackListItemClick, messages } from '../../lib';

interface BaseRequestFormListItemProps {
  provider: ExtendedProvider;
  log: Log;
}
type RequestFormListItemProps = BaseRequestFormListItemProps &
  WrappedComponentProps;

export const RequestFormListItem = injectIntl(
  ({ provider, intl, log }: RequestFormListItemProps) => {
    const primaryText = intl.formatMessage(messages.requestFormTitle);
    const secondaryText =
      intl.formatMessage(messages.requestFormSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.requestFormSubtitle);

    const href = provider.request_appointment_url ?? undefined;

    const handleClick = () => {
      trackListItemClick({
        log,
        listItem: DefaultCtaListItem.RequestForm,
        providerId: provider.id,
        primaryText,
        secondaryText
      });
    };

    const buttonProps: ListItemButtonProps = {
      component: 'a',
      href,
      role: 'link',
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: handleClick
    };
    return (
      <CtaListItemBase
        buttonProps={buttonProps}
        isExternalLink={true}
        primaryText={primaryText}
        secondaryText={secondaryText}
      />
    );
  }
);
